module.exports = __webpack_public_path__ + "img/no_cover.7d034626.jpg";